export default __webpack_public_path__ + "static/media/element_50.1eecc0ca.avif";